/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, November 6th 2022, 9:01:16 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { schemaBuilder, Many2OneIntPKBaseSchema } from "lib/validation";
import {
  ProcessTemplateArtifact,
  ProcessTemplateArtifactValidationSchema,
  ProcessTemplateArtifactSchemaType,
} from "lib/schemas";
import { WritableModel } from "lib/schemas/abstract";

export enum SOURCE_RESOURCE_TYPES {
  soap = "SOAP",
  http = "HTTP",
}

export enum SOURCE_REQUEST_METHODS {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  PATCH = "PATCH",
  DELETE = "DELETE",
}

export interface AjaxSource extends ProcessTemplateArtifact, WritableModel<false> {
  source_parameters: AjaxSourceParameter[];
  name: string;
  source: string;
  resource_type: keyof typeof SOURCE_RESOURCE_TYPES;
  request_method: keyof typeof SOURCE_REQUEST_METHODS;
  soap_call: string;
}

export interface AjaxSourceParameter extends ProcessTemplateArtifact, WritableModel<false> {
  key: string;
  value: string;
  sequence: number;
  source: number;
}

export const AjaxSourceParameterValidationSchema: ProcessTemplateArtifactSchemaType<Omit<AjaxSourceParameter, "id">> =
  ProcessTemplateArtifactValidationSchema.shape({
    key: schemaBuilder.string().required("Key is required"),
    value: schemaBuilder.string().required("Value is required"),
    sequence: schemaBuilder.number().required("Sequence is required"),
    source: Many2OneIntPKBaseSchema().nullable(),
  });

export const AjaxSourceValidationSchema = ProcessTemplateArtifactValidationSchema.shape({
  name: schemaBuilder.string().required("Name is required").typeError("Kindly provide a valid string for the name."),
  source: schemaBuilder
    .string()
    .url()
    .required("Kindly provide the url for the remote source.")
    .typeError("Kindly provide a valid URL."),
  resource_type: schemaBuilder.mixed().oneOf(Object.keys(SOURCE_RESOURCE_TYPES)),
  request_method: schemaBuilder.mixed().oneOf(Object.keys(SOURCE_REQUEST_METHODS)),
  source_parameters: schemaBuilder.array(AjaxSourceParameterValidationSchema).optional().default([]),
  soap_call: schemaBuilder.string().default(""),
});
